import { resolveResponsiveFactor } from '../../resolvers/ComposedResolvers';
import resolveResponsiveValue from '../../resolvers/ResponsiveValueResolver';
export default function resolvePosition(theme, screenWidth, positionSupport) {
    var result = {};
    if (positionSupport.positionAbsolute !== undefined) {
        var positionAbsolute = resolveResponsiveValue(theme, screenWidth, positionSupport.positionAbsolute);
        // ToDo: maybe relative?
        result.position = positionAbsolute ? 'absolute' : 'relative';
    }
    if (positionSupport.positionAbsoluteFill !== undefined) {
        var positionAbsoluteFill = resolveResponsiveValue(theme, screenWidth, positionSupport.positionAbsoluteFill);
        if (positionAbsoluteFill) {
            result.position = 'absolute';
            result.top = 0;
            result.bottom = 0;
            result.right = 0;
            result.left = 0;
        }
    }
    if (positionSupport.topBottom !== undefined) {
        var topBottom = resolveResponsiveFactor(theme, screenWidth, positionSupport.topBottom);
        result.top = topBottom;
        result.bottom = topBottom;
    }
    if (positionSupport.rightLeft !== undefined) {
        var rightLeft = resolveResponsiveFactor(theme, screenWidth, positionSupport.rightLeft);
        result.right = rightLeft;
        result.left = rightLeft;
    }
    if (positionSupport.top !== undefined) {
        result.top = resolveResponsiveFactor(theme, screenWidth, positionSupport.top);
    }
    if (positionSupport.bottom !== undefined) {
        result.bottom = resolveResponsiveFactor(theme, screenWidth, positionSupport.bottom);
    }
    if (positionSupport.right !== undefined) {
        result.right = resolveResponsiveFactor(theme, screenWidth, positionSupport.right);
    }
    if (positionSupport.left !== undefined) {
        result.left = resolveResponsiveFactor(theme, screenWidth, positionSupport.left);
    }
    return result;
}
//# sourceMappingURL=PositionResolver.js.map